import {useContext} from 'react'

import Context from '@s-ui/react-context'

import {CONTACT_ACTION_IDS} from '../contracts.js'
import {isPrivateSellerContract} from '../helpers/sellerType.js'

const useAvailableActions = ({contractId, hidePhone, hasWhatsapp, hasWhatsappProduct = false}) => {
  const {domain} = useContext(Context)

  const config = domain.get('config')
  const {PRIVATE_CONTRACT_ID} = config.get('dealer')
  const isDealer = !isPrivateSellerContract({
    contractId,
    privateContractId: PRIVATE_CONTRACT_ID,
    whenMissingContractId: false
  })

  const isWhatsappAvailable = Boolean(hasWhatsapp) && isDealer && hasWhatsappProduct

  return {
    [CONTACT_ACTION_IDS.PHONE]: {available: !hidePhone, iconOnlyCapable: true},
    [CONTACT_ACTION_IDS.MESSAGE]: {available: true, iconOnlyCapable: true},
    [CONTACT_ACTION_IDS.WHATSAPP]: {available: isWhatsappAvailable}
  }
}

export default useAvailableActions
